const FLIGHT_SQL_MARKER = '[FlightSQL]';
const MAX_ERROR_DESCRIPTION_LENGTH = 150;
const TERMS_TO_REMOVE = ['[Simba][BigQueryJDBCDriver](100032)'];

function extractQueryErrorShortDescription(errorMessage: string): string {
  if (errorMessage.includes(FLIGHT_SQL_MARKER)) {
    const startIndex =
      errorMessage.indexOf(FLIGHT_SQL_MARKER) + FLIGHT_SQL_MARKER.length + 1;
    let description = errorMessage.substring(startIndex).trim();

    for (const term of TERMS_TO_REMOVE) {
      description = description.replace(term, '').trim();
    }

    if (description.length > MAX_ERROR_DESCRIPTION_LENGTH) {
      return `${description.substring(0, MAX_ERROR_DESCRIPTION_LENGTH)}...`;
    }

    return description;
  }

  return 'Unknown error';
}

export const getHumanReadableQueryError = (
  errorCategory?: string | null,
  error?: string | null,
): string => {
  if (!error || !errorCategory) {
    return 'Issue found';
  }

  switch (errorCategory) {
    case 'ProgrammingError':
      return extractQueryErrorShortDescription(error);
    default:
      return 'Issue found';
  }
};
